import { render, staticRenderFns } from "./AdminWalletPage.vue?vue&type=template&id=348d564a&scoped=true"
import script from "./AdminWalletPage.vue?vue&type=script&lang=js"
export * from "./AdminWalletPage.vue?vue&type=script&lang=js"
import style0 from "./AdminWalletPage.vue?vue&type=style&index=0&id=348d564a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348d564a",
  null
  
)

export default component.exports